enum FileSizeLimits {
  MAX_FILE_SIZE = 10000000,
  MIN_FILE_SIZE = 100,
}

export default FileSizeLimits;
